const AUTH_RETURN_STORAGE_KEY = 'tyrebase:auth-return';
const AUTH_PAGE_PATTERN = /^\/(?:login|registration|verify-email|recovery-password|reset-password)(?:\/|$)/i;
let pendingReturnPath: string | null = null;

/** Страницы входа не могут быть целью возврата после авторизации. */
export const isAuthPage = (pathname: string): boolean => AUTH_PAGE_PATTERN.test(pathname);


const hasUnsafePathCharacters = (value: string): boolean => Array.from(value).some(character => {
    const code = character.charCodeAt(0);
    return character === '\\' || code < 32 || code === 127;
});

const safeReturnPath = (value: unknown): string | null => {
    if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')
        || hasUnsafePathCharacters(value)) return null;
    try {
        const url = new URL(value, window.location.origin);
        const pathname = decodeURIComponent(url.pathname);
        if (url.origin !== window.location.origin || pathname.startsWith('//')
            || hasUnsafePathCharacters(pathname) || isAuthPage(pathname)) return null;
        // Сохраняем параметры поиска, но не токены доступа из специальных ссылок.
        ['token', 'share_token', 'invite_code', 'view_access_id', 'access_id'].forEach(key => url.searchParams.delete(key));
        return url.pathname + url.search + url.hash;
    } catch {
        return null;
    }
};

/** Сохраняет только внутренний адрес в текущей вкладке, включая фильтры и страницу. */
export const rememberAuthReturnPath = (path: string): void => {
    pendingReturnPath = safeReturnPath(path);
    try {
        if (pendingReturnPath) sessionStorage.setItem(AUTH_RETURN_STORAGE_KEY, pendingReturnPath);
        else sessionStorage.removeItem(AUTH_RETURN_STORAGE_KEY);
    } catch {
        // При запрете storage переход в текущем приложении работает через память.
    }
};

/** Отмена входа или завершение возврата не должны влиять на следующий вход. */
export const clearAuthReturnPath = (): void => {
    pendingReturnPath = null;
    try {sessionStorage.removeItem(AUTH_RETURN_STORAGE_KEY);} catch {}
};

/** Однократно забирает адрес после успешного входа или подтверждения email. */
export const takeAuthReturnPath = (): string | null => {
    let path = pendingReturnPath;
    try {path = sessionStorage.getItem(AUTH_RETURN_STORAGE_KEY) ?? path;} catch {}
    clearAuthReturnPath();
    return safeReturnPath(path);
};
